import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  DOCUMENT,
} from '@angular/core';
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CompressedImagesDto } from 'app/shared/azure-blob/blob-compress.service';
import { BlobStorageService } from 'app/shared/azure-blob/blob-storage.service';
import { FileSetttings } from 'app/shared/data.service';
import { TenantHomeUpdateModel } from 'app/state/tenants.repository';
declare var ClassicEditor: any;
import {
  MediaLibraryFileSelectorOptions,
  MediaLibraryService,
} from 'app/api/services/mediaLibrary.service';
import { MediaLibraryFileDto } from 'app/api/models/mediaLibrary/mediaLibraryFileDto';
@Component({
  selector: 'app-tenant-html-form',
  templateUrl: './tenant-html-form.component.html',
  styleUrls: ['./tenant-html-form.component.scss'],
  standalone: false,
})
export class TenantHtmlFormComponent {
  editor: any;
  editor2: any;
  editor3: any;
  tenant_form!: UntypedFormGroup;

  logoMediaLibraryFile?: MediaLibraryFileDto;

  @Input() tenantModel!: TenantHomeUpdateModel;
  @Output() submitedValue = new EventEmitter<TenantHomeUpdateModel>();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private formBuilder: UntypedFormBuilder,
    public mediaLibraryService: MediaLibraryService,
  ) {}

  ngOnInit() {
    this.createEmptyFormGroup();
    this.setUpForm();
  }

  ngAfterViewInit() {
    // PrimeNG's p-editor loads Quill asynchronously and only renders the
    // form value if it is set at the exact moment Quill finishes
    // initialising. When several editors share one form patched in
    // ngOnInit, the later editors (pageHtml2 / descriptionMobile) routinely
    // miss their initial value. Re-applying the model after the view has
    // settled pushes the values through once every editor is attached.
    setTimeout(() => {
      if (this.tenantModel) {
        this.setUpForm();
      }
    });
  }

  setUpForm() {
    // Keep the preview in sync with the saved logo so it shows when editing.
    this.logoMediaLibraryFile = this.tenantModel.logo ?? undefined;
    this.tenant_form.patchValue({
      image: this.tenantModel.logo ?? undefined,
      headline: this.tenantModel.headline ?? '',
      pageHtml: this.tenantModel.pageHtml ?? '',
      videoUrl: this.tenantModel.videoUrl ?? '',
      pageHtml2: this.tenantModel.pageHtml2 ?? '',
      descriptionMobile: this.tenantModel.descriptionMobile ?? '',
      hasCompressedImage320: this.tenantModel.hasCompressedImage320 ?? false,
      hasCompressedImage800: this.tenantModel.hasCompressedImage800 ?? false,
      isFileOnRightBlob: this.tenantModel.isFileOnRightBlob ?? false,
    });
  }

  createEmptyFormGroup(): void {
    this.tenant_form = this.formBuilder.group({
      image: new FormControl(``),
      headline: new FormControl(``),
      pageHtml: new FormControl(``),
      videoUrl: new FormControl(``, [Validators.pattern('(https://.*)')]),
      pageHtml2: new FormControl(``),
      descriptionMobile: new FormControl(``),
      hasCompressedImage320: new FormControl(``),
      hasCompressedImage800: new FormControl(``),
      isFileOnRightBlob: new FormControl(``),
    });
  }

  changeHasCompressedImage(value: CompressedImagesDto) {
    this.tenant_form.controls['hasCompressedImage320'].setValue(
      value.hasCompressedImage320,
    );
    this.tenant_form.controls['hasCompressedImage800'].setValue(
      value.hasCompressedImage800,
    );
  }

  // ngAfterViewInit() {
  //   if (typeof ClassicEditor !== 'function') {
  //     var script = this.document.createElement('script');
  //     script.type = 'text/javascript';
  //     script.src = '/assets/js/ckeditor.js';
  //     this.document.body.appendChild(script);
  //     script.onload = () => {
  //       this.initEditor('editor');
  //       this.initEditor('editor2');
  //       this.initEditor('editor3');
  //     };
  //   } else {
  //     this.initEditor('editor');
  //     this.initEditor('editor2');
  //     this.initEditor('editor3');
  //   }
  // }

  // private initEditor(editorName: string) {
  //   ClassicEditor.create(document.querySelector('#' + editorName), {
  //     toolbar: [
  //       'heading',
  //       'bold',
  //       'italic',
  //       '|',
  //       'undo',
  //       'redo',
  //       '|',
  //       'numberedList',
  //       'bulletedList',
  //     ],
  //   }).then((newEditor: any) => {
  //     if (editorName == 'editor') {
  //       newEditor.setData(this.tenantModel.pageHtml);
  //       this.editor = newEditor;
  //     }

  //     if (editorName == 'editor2') {
  //       newEditor.setData(this.tenantModel.pageHtml2);
  //       this.editor2 = newEditor;
  //     }
  //     if (editorName == 'editor3') {
  //       newEditor.setData(this.tenantModel.descriptionMobile);
  //       this.editor3 = newEditor;
  //     }
  //   });
  // }

  onSubmit() {
    // const pageHtml = this.editor.getData();
    // const pageHtml2 = this.editor2.getData();
    // const descriptionMobile = this.editor3.getData();
    // this.tenant_form.patchValue({
    //   pageHtml: pageHtml,
    //   pageHtml2: pageHtml2,
    //   descriptionMobile: descriptionMobile,
    // });

    const model: TenantHomeUpdateModel = {
      logo: this.tenant_form.controls['image'].value ?? undefined,
      pageHtml: this.tenant_form.controls['pageHtml'].value ?? null,
      videoUrl: this.tenant_form.controls['videoUrl'].value ?? null,
      pageHtml2: this.tenant_form.controls['pageHtml2'].value ?? null,
      descriptionMobile:
        this.tenant_form.controls['descriptionMobile'].value ?? null,
      headline: this.tenant_form.controls['headline'].value ?? null,
      hasCompressedImage320:
        this.tenant_form.controls['hasCompressedImage320'].value,
      hasCompressedImage800:
        this.tenant_form.controls['hasCompressedImage800'].value,
      isFileOnRightBlob: this.tenant_form.controls['isFileOnRightBlob'].value,
    };
    console.log(model);
    this.submitedValue.emit(model);
  }

  updateFile(settings: Partial<FileSetttings>) {
    this.tenant_form.patchValue({
      image: settings.uploadedFileName,
      isFileOnRightBlob: true,
    });
  }

  deleteLogo() {
    this.tenant_form.patchValue({
      image: '',
    });
  }
  addMediaLibraryFile() {
    let options = new MediaLibraryFileSelectorOptions();
    options.allowImagesSelection = true;
    options.showOnlyPrivateFiles = true;

    this.mediaLibraryService
      .selectFileFromMediaLibraryInModalOptions(options)
      .subscribe((data) => {
        if (data) {
          this.logoMediaLibraryFile = data[0];
          // Persist the selection into the form control that onSubmit reads,
          // otherwise the chosen image is never saved.
          this.tenant_form.get('image')?.setValue(data[0]);
        }
      });
  }

  removeImage() {
    this.logoMediaLibraryFile = undefined;
  }
}
